import { useState } from "react";
import {
  Button,
  Fieldset,
  Form,
  TextInput,
} from "@datapay-by-datacom/design-system";
import { OrgCategory } from "../../../generated/core-api";
import { useUpdateOrgName } from "../../hooks/Org/useUpdateOrgName";
import styles from "./OrgSettings.module.css";

interface OrgNameFormProps {
  category: OrgCategory;
  id: string;
  name: string;
}

export function OrgNameForm({ category, id, name }: OrgNameFormProps) {
  const [orgName, setOrgName] = useState(name);
  const [isSuccess, setIsSuccess] = useState(false);
  const { mutate: updateOrgName, isPending } = useUpdateOrgName();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (orgName.trim() === "") return;

    updateOrgName(
      {
        category,
        orgId: id,
        name: orgName,
      },
      {
        onSuccess: () => {
          setIsSuccess(true);
          setTimeout(() => setIsSuccess(false), 3000);
        },
      }
    );
  };

  const handleChange = (value: string) => {
    setOrgName(value);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Fieldset>
        <TextInput
          label="Organization Name"
          value={orgName}
          onChange={handleChange}
        />

        <Button
          type="submit"
          isDisabled={isPending || orgName.trim() === "" || orgName === name}
        >
          {isPending ? "Updating..." : "Update Name"}
        </Button>

        {isSuccess && (
          <span className={styles.successMessage}>
            Organization name updated successfully!
          </span>
        )}
      </Fieldset>
    </Form>
  );
}
